import type { QueryStatus } from '@tanstack/react-query';

export function hasFailedWithoutData(state: { status: QueryStatus; data: unknown }) {
  return state.status === 'error' && state.data === undefined;
}
